import type { ReactNode } from 'react'

import { VIEW_TAB_TEST_ID_PREFIX } from './consts'

export const getViewTabTestId = (label: ReactNode): string => `${VIEW_TAB_TEST_ID_PREFIX}${label}`
